<template>
  <validation-provider v-slot="{ errors }" vid="custom">
    <input hidden />
    <transition name="fade">
      <template v-if="errors[0]">
        <div class="d-flex align-items-center mb-4">
          <icon-info />
          <span class="error-yellow">{{ errors[0] }}</span>
        </div>
      </template>
    </transition>
  </validation-provider>
</template>
<script>
  import IconInfo from '@shared/components/icon/icon-svg-info';
  export default {
    components: { IconInfo }
  };
</script>
<style lang="scss">
  .error-yellow {
    text-align: left;
    margin-left: 15px;
    font-size: 14px;
    letter-spacing: 0.3px;
    color: #f1cb1c;
  }
</style>
